export default __webpack_public_path__ + "static/media/devto.c40b8d79.svg";